import React, { Component } from "react";
import { Container } from "semantic-ui-react";

export default class General extends Component {
  render() {
    return (
      <Container textAlign="center">
        <div class="card">
          <div class="card-body'">

        <div className="container text-center"> </div>
        </div>
        </div>

      </Container>
    );
  }
}
